/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { RepairHistoryDetailedModel } from '../models/RepairHistoryDetailedModel';
import type { RepairHistoryShortModel } from '../models/RepairHistoryShortModel';
import type { SetRepeatRepairModel } from '../models/SetRepeatRepairModel';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class RepairHistoryService {

  /**
   * @param regno 
   * @param dateFrom 
   * @param dateTo 
   * @param wipNo 
   * @param serviceBookingId 
   * @returns RepairHistoryShortModel Success
   * @throws ApiError
   */
  public static getRepairHistoryRecords(
regno?: string,
dateFrom?: string,
dateTo?: string,
wipNo?: number,
serviceBookingId?: number,
): CancelablePromise<Array<RepairHistoryShortModel>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/repair-history/records',
      query: {
        'regno': regno,
        'dateFrom': dateFrom,
        'dateTo': dateTo,
        'wipNo': wipNo,
        'serviceBookingId': serviceBookingId,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param soHeaderId 
   * @returns RepairHistoryDetailedModel Success
   * @throws ApiError
   */
  public static getRepairHistory(
soHeaderId?: number,
): CancelablePromise<RepairHistoryDetailedModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/repair-history',
      query: {
        'soHeaderId': soHeaderId,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns boolean Success
   * @throws ApiError
   */
  public static postRepairHistoryRepeatRepair(
requestBody?: SetRepeatRepairModel,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/repair-history/repeat-repair',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @returns boolean Success
   * @throws ApiError
   */
  public static postRepairHistoryRepeatRepairUpdate(): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/repair-history/repeat-repair/update',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

}
